import {BattedBallType} from '../enums/index.js';

const battedBallTypeClassifier = function(verticalLaunchAngle) {
    if (typeof(verticalLaunchAngle) !== 'number'){
        return BattedBallType.Unidentified.key;
    }

    // based on http://m.mlb.com/glossary/statcast/launch-angle
    if (verticalLaunchAngle < 10){
        return BattedBallType.GroundBall.key;
    }

    if (verticalLaunchAngle < 25){
        return BattedBallType.LineDrive.key;
    }

    if (verticalLaunchAngle < 50){
        return BattedBallType.FlyBall.key;
    }

    return BattedBallType.PopUp.key;
};

export default battedBallTypeClassifier;